<!--
    描述：评价设置
    时间：2022-5-18 11:03:14
    Created by 钱磊
-->
<template>
	<div class="audit operation-layout h100" :class="{ pd0: !routeQuery }">
		<!-- 列表查询页 -->
		<filter-layout @search="doSearch('1')" @reset="doRefresh" v-if="!routeQuery">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchObj" label-width="120px">
					<el-form-item label="规则名称：" prop="sname">
						<el-input :placeholder="'请输入'" clearable v-model="searchObj.sname"></el-input>
					</el-form-item>
					<el-form-item label="评价应用：" prop="applyBus">
						<el-select v-model="searchObj.applyBus" placeholder="请选择评价应用" clearable>
							<el-option
								v-for="(item, index) in yyyw"
								:key="index"
								:label="item.sname"
								:value="item.value"
								:disabled="item.disabled"
							></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							总共设置了<span class="blue">{{ searchObj.totalResult }}</span> 项内容
						</div>
						<div class="btnGroups">
							<el-button class="btn-success" size="small" @click="handleTools('add')">新增</el-button>
						</div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<vxe-table
								:data="tableObj.tableData"
								:loading="tableObj.loading"
								:border="tableObj.border"
								:resizable="tableObj.resizable"
								:size="tableObj.size"
								:height="tableObj.height"
								highlight-current-row
								highlight-hover-row
								show-overflow="tooltip"
								v-show="tableShow"
								show-header-overflow="tooltip"
							>
								<vxe-table-column type="seq" title="序号" align="center" width="70"></vxe-table-column>
								<vxe-table-column
									field="sname"
									title="规则名称"
									header-align="center"
									min-width="200"
									show-overflow-tooltip
								></vxe-table-column>
								<vxe-table-column field="applyBusName" title="评价应用" align="center" width="100"> </vxe-table-column>
								<vxe-table-column field="assItemsName" title="评价维度" align="center" width="300"></vxe-table-column>
								<vxe-table-column title="单项" align="center" width="150">
									<img src="@/assets/images/rateValue.png" alt="" />
								</vxe-table-column>
								<vxe-table-column field="singleScore" title="单项/分值" align="center" width="90"></vxe-table-column>
								<vxe-table-column field="totalScore" title="单项总分" align="center" width="90"></vxe-table-column>
								<vxe-table-column field="createUser" title="创建人" align="center" width="90"></vxe-table-column>
								<vxe-table-column field="createDate" title="创建时间" align="center" width="120">
									<template v-slot="{ row }">
										{{ row.createDate.split(' ')[0] }}
									</template>
								</vxe-table-column>
								<vxe-table-column title="配置启用/关闭" align="center" width="150">
									<template v-slot="{ row }">
										<vxe-switch
											v-model="row.ruleStatus"
											open-label="启用"
											:open-value="1"
											close-label="关闭"
											:close-value="0"
											@change="changeStatus(row)"
										></vxe-switch>
									</template>
								</vxe-table-column>
								<vxe-table-column title="操作" min-width="160" align="center">
									<template v-slot="{ row }">
										<el-button
											type="success"
											size="small"
											round
											plain
											class="table-btn"
											:disabled="row.ruleStatus == 1"
											@click="handleTools('edit', row)"
										>
											<svg-icon icon-class="form-edit"></svg-icon> 编辑
										</el-button>
										<el-button
											type="danger"
											size="small"
											round
											plain
											class="table-btn"
											icon="el-icon-delete"
											:disabled="row.ruleStatus == 1 || row.isUsed == '1'"
											@click="handleTools('delete', row)"
											>删除
										</el-button>
									</template>
								</vxe-table-column>
							</vxe-table>
						</div>
						<div class="w-table-footer">
							<vxe-pager
								size="mini"
								:current-page="searchObj.currentPage"
								:page-size="searchObj.pageSize"
								:total="searchObj.totalResult"
								class="text-center"
								:page-sizes="[10, 20, 50, 100]"
								:layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump']"
								@page-change="handlePageChange"
							>
							</vxe-pager>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<template v-else>
			<AddSetting @close="doSearch"></AddSetting>
		</template>
	</div>
</template>

<script>
import AddSetting from './components/AddSetting'
import { mapState } from 'vuex'
import { getRulePageList, delAssessRule, updateStatus } from 'api/modules/assessment-system/AssessmentSetting'

export default {
	components: {
		AddSetting
	},
	data() {
		return {
			showFilter: true,
			searchObj: {
				sname: '', // 规则名称
				applyBus: '', // 应用业务（码表）
				currentPage: 1, // 当前页码
				pageSize: 10, // 当前每页条数
				totalResult: 0
			},
			// 表格对象
			tableObj: {
				tableData: [],
				loading: false,
				border: true,
				resizable: true,
				size: 'small',
				height: '100%'
			},
			searchToggle: true, //筛选控制
			tableShow: true //表格显隐控制
		}
	},
	created() {
		this.doSearch()
	},
	methods: {
		// 查询评价设置列表
		doSearch(page) {
			if (page) {
				this.searchObj.pageSize = 10
				this.searchObj.currentPage = 1
			}
			let params = {
				size: this.searchObj.pageSize, // 当前每页条数
				current: this.searchObj.currentPage, // 当前页码
				sname: this.searchObj.sname, // 规则名称
				applyBus: this.searchObj.applyBus // 应用业务（码表）
			}
			this.tableObj.loading = true
			getRulePageList(params)
				.then((res) => {
					this.tableObj.loading = false
					if (res.operationCode === 1) {
						this.tableObj.tableData = res.data.records
						this.searchObj.totalResult = parseInt(res.data.total)
						this.tableObj.tableData.forEach((item) => {
							let _item = this.yyyw.filter((val) => {
								return val.value == item.applyBus
							})
							item.applyBusName = _item[0].sname //评价应用码表转名称
							let item1 = item.assItems.split(',')
							let item2 = ''
							item1.map((item) => {
								let _item1 = this.pjwd.filter((val) => {
									return val.value == item
								})
								item2 += _item1[0].sname + ','
							})
							item2 = item2.substring(0, item2.length - 1)
							item.assItemsName = item2 //评价维度码表转名称
						})
					}
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},
		//刷新/重置
		doRefresh() {
			this.searchObj.pageSize = 10
			this.searchObj.currentPage = 1
			this.searchObj.sname = ''
			this.searchObj.applyBus = ''
			this.doSearch()
		},
		// 当启用状态发生变化时
		changeStatus(row) {
			let _flag = row.ruleStatus
			row.ruleStatus = row.ruleStatus == 0 ? 1 : 0
			let tipMsg = row.ruleStatus
				? `请确定关闭配置，关闭后${row.applyBusName}项目评价功能将无法使用！`
				: `请确定开启配置，开启后${row.applyBusName}项目评价将会被更新！`
			this.$confirm(`${tipMsg}`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then((res) => {
					let params = {
						id: row.id,
						ruleStatus: _flag
					}
					updateStatus(params)
						.then((res) => {
							if (res.operationCode === 1) {
								this.$message.success('设置成功！')
								this.doSearch()
							}
						})
						.catch((err) => {})
				})
				.catch(() => {
					this.$message.info('已取消操作！')
				})
		},
		// 右侧操作
		handleTools(type, row) {
			switch (type) {
				case 'delete':
					this.$confirm('请再次确认需要删除该配置内容', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							delAssessRule({ id: row.id })
								.then((res) => {
									if (res.operationCode === 1) {
										this.$message.success(res.msg)
									}
									// 刷新页面
									this.doSearch()
								})
								.catch((err) => {})
						})
						.catch(() => {})
					break
				case 'add':
					this.$router.push({
						path: '/assessment-setting',
						query: {
							type: 'add'
						}
					})
					break
				default:
					let rowObj = Object.assign({}, row)
					// 存值
					this.$setSessionItem('evaluateInfo', JSON.stringify(rowObj))
					// 存值
					this.$setSessionItem('searchObj', JSON.stringify(this.searchObj))
					this.$setSessionItem('currentPage', JSON.stringify(this.searchObj.currentPage))
					this.$setSessionItem('pageSize', JSON.stringify(this.searchObj.pageSize))
					this.$router.push({
						path: '/assessment-setting',
						query: {
							type: 'edit'
						}
					})
			}
		},
		// 切换状态
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 切换分页
		handlePageChange({ currentPage, pageSize }) {
			this.searchObj.currentPage = currentPage
			this.searchObj.pageSize = pageSize
			this.doSearch()
		}
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('app', { isBack: (state) => state.isBack }),
		...mapState('dict', {
			yyyw: (state) => state.yyyw,
			pjwd: (state) => state.pjwd
		})
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		}
	}
}
</script>

<style></style>
